"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const multicoloredcircles_webp_1 = __importDefault(require("root/src/client/public/animation/multicoloredcircles.webp"));
const image_1 = __importDefault(require("next/future/image"));
const LoadingCircles = (_a) => {
    var { width = 200, height = 200 } = _a, props = __rest(_a, ["width", "height"]);
    return (<div className="flex self-center justify-self-center justify-center">
		<image_1.default className="flex flex-initial self-center justify-self-center" src={multicoloredcircles_webp_1.default.src} alt="multicolored circles" width={width} height={height} unoptimized {...props}/>
	</div>);
};
exports.default = LoadingCircles;
